<ng-container *ngIf="selectedCard$ | async as selectedCard">
    <gl-cards-page-layout-container secondMainAreaEnabled="true">
        <ng-container *ngTemplateOutlet="headerTemplate" header></ng-container>

        <div desktop-header-sub-content>
            <div class="box-border border-b border-solid border-black border-opacity-10"></div>
            <div class="m-2">
                <ridango-ui-back-button (onBack)="navigateCardsView()"
                    >{{ 'LOCAL_BTN_BACK' | translate }}
                </ridango-ui-back-button>
            </div>
        </div>

        <div class="flex flex-col gap-4" main-1>
            <div class="bg-white px-2">
                <rwidget-card-details-overview [card]="selectedCard"></rwidget-card-details-overview>
            </div>
            <div class="mb-4 bg-white px-2 lg:mb-0">
                <rwidget-card-tickets-list [card]="selectedCard"></rwidget-card-tickets-list>
            </div>
        </div>

        <div class="bg-white px-2" main-2-mobile>
            <rwidget-card-contextual-menu
                [card]="selectedCard"
                (addMoneyClick)="navigateToCardWallet(selectedCard)"
                (blockClick)="blockCardModal.openModal(selectedCard)"
                (goToPurchaseFlow)="navigateToPurchaseFlow(selectedCard)"
                (unBlockClick)="unBlockCard(selectedCard)"
                (removeClick)="removeCardModal.openModal(selectedCard)"
                (editDataClick)="navigateToEditView(selectedCard)"></rwidget-card-contextual-menu>
        </div>
        <div main-2-desktop>
            <rwidget-card-contextual-menu
                [card]="selectedCard"
                (addMoneyClick)="navigateToCardWallet(selectedCard)"
                (blockClick)="blockCardModal.openModal(selectedCard)"
                (goToPurchaseFlow)="navigateToPurchaseFlow(selectedCard)"
                (unBlockClick)="unBlockCard(selectedCard)"
                (removeClick)="removeCardModal.openModal(selectedCard)"
                (editDataClick)="navigateToEditView(selectedCard)"></rwidget-card-contextual-menu>
        </div>
    </gl-cards-page-layout-container>

    <ng-template #headerTemplate>
        <!-- MOBILE -->
        <div class="mb-3 grid w-full grid-cols-[4rem_1fr_4rem] bg-white py-3 md:hidden">
            <ion-button
                class="pn-light:text-primary pn-app-light:text-primary text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                (click)="navigateCardsView()"
                fill="clear"
                size="small">
                <ion-icon
                    class="mr-1 text-base dark:filter-yellow"
                    title="{{ 'LOCAL_BTN_BACK' | translate }}"
                    aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                    src="{{ assetsPath$ | async }}/img/cards/icon-left-arrow.svg"></ion-icon>
            </ion-button>
            <div class="flex items-center justify-center">
                <h1 class="text-base font-semibold">{{ 'CARD_DETAILS' | translate }}</h1>
            </div>
        </div>

        <!-- DESKTOP -->
        <h1 class="hidden text-[2.75rem] leading-10 md:block">{{ 'CARD_DETAILS' | translate }}</h1>
    </ng-template>

    <rwidget-card-block-modal #blockCardModal></rwidget-card-block-modal>
    <rwidget-card-remove-modal #removeCardModal></rwidget-card-remove-modal>
</ng-container>
